module.exports = __webpack_public_path__ + "static/free-trial-44f2490e490e820621829149c15c60f1.svg";